/**
 * Wrapper for crypto.randomUUID() with provided polyfill.
 *
 * Polyfill based on
 * https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid/2117523#2117523
 * on May 31, 2022.
 */
const crypto = typeof window !== "undefined" ? (window.crypto ?? {}) : {};

export function randomUUIDPolyfill(): string {
    // Fall back to the more widely-supported getRandomValues()
    return `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, (c) =>
        (
            Number(c) ^
            // @ts-expect-error - TS2339 - Property 'getRandomValues' does not exist on type '{}'.
            (crypto.getRandomValues(new Uint8Array(1))[0] &
                (15 >> (Number(c) / 4)))
        ).toString(16),
    );
}

export const randomUUID: () => string =
    "randomUUID" in crypto
        ? function randomUUID() {
              // The `"randomUUID" in` check verifies that `randomUUID` exists on `crypto`
              // @ts-expect-error - TS2339 - Property 'randomUUID' does not exist on type '{}'.
              return crypto.randomUUID();
          }
        : randomUUIDPolyfill;
